import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { ReactComponent as ApproveOutline16 } from 'assets/svgs/approve-outline.svg';
import { Button } from 'components/atoms/button';
import styles from './approval.module.css';

interface ApprovalActions {
  isLoading: boolean;
  onApprove: () => void;
  onRequestChanges: () => void;
}

export const ApprovalActions: FC<ApprovalActions> = (props) => {
  const { onApprove, onRequestChanges, isLoading } = props;

  return (
    <div className={styles.cta__wrapper}>
      <Button
        loading={isLoading}
        type="primary"
        size="small"
        onClick={onApprove}
        icon={<ApproveOutline16 />}
      >
        <FormattedMessage id="approvals.approve" />
      </Button>
      <Button
        className={styles.cta__cancel}
        type="default"
        size="small"
        onClick={onRequestChanges}
        disabled={isLoading}
      >
        <FormattedMessage id="approvals.change_required" />
      </Button>
    </div>
  );
};
